import { NodeType, TableNodeProperties } from "@features/builder/graph/types"
import NodeDrawerAccordion from "@features/builder/NodeDrawer/NodeDrawerAccordion"
import { Button, Grid } from "@mui/material"
import TableMnemonicTable from "@features/builder/NodeDrawer/NodeForm/NodeMnemonicTableAccordion/TableMnemonicTable"
import Add from "@mui/icons-material/Add"
import { useFormContext } from "react-hook-form"
import { NodeFormValues } from "@features/builder/NodeDrawer/NodeForm"

export default function NodeMnemonicTableAccordion(props: {
  nodeId: string
  onPropertiesUpdate: (properties: TableNodeProperties) => void
  nodeType: NodeType.ForecastTable | NodeType.ScenarioTable
}) {
  const form = useFormContext<NodeFormValues>()

  const handleAddColumn = () => {
    const updatedProperties = structuredClone(form.getValues("attributeProperties"))
    updatedProperties.columns.push(`col${updatedProperties.columns.length + 1}`)
    updatedProperties.data.map((row) => row.push(""))
    props.onPropertiesUpdate(updatedProperties)
  }

  const handleAddRow = () => {
    const updatedProperties = structuredClone(form.getValues("attributeProperties"))

    const row = Array(updatedProperties.data[0]?.length).fill("")
    updatedProperties.index.push(`row${updatedProperties.data.length + 1}`)
    updatedProperties.data.push(row)
    props.onPropertiesUpdate(updatedProperties)
  }
  return (
    <NodeDrawerAccordion id="table-atributes" label="Table Data">
      <Grid container item gap={1}>
        <Grid item>
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={handleAddRow}
            disabled={form.formState.disabled}
          >
            Add row
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={handleAddColumn}
            disabled={form.formState.disabled}
          >
            Add column
          </Button>
        </Grid>
      </Grid>
      <Grid item>
        <TableMnemonicTable
          nodeId={props.nodeId}
          nodeType={props.nodeType}
          onPropertiesUpdate={props.onPropertiesUpdate}
        />
      </Grid>
    </NodeDrawerAccordion>
  )
}
